import { h as __h } from "preact";
import html from "~/util/html.js";
import CopyBox from "~/component/CopyBox.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./FreshKeyCallout.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./FreshKeyCallout.module.css", import.meta.url);
const css = adopt(sheet);

/** @typedef {{ name: string; secret: string }} FreshKey */

/**
 * @param {Props} props
 *
 * @typedef {object} Props
 * @property {FreshKey | null} freshKey
 */
export default function FreshKeyCallout(props) {
  if (props.freshKey === null) return null;
  return __h("div", {
    "class": css.callout
  }, __h("p", {}, "Your new key ", __h("strong", {}, props.freshKey.name), " has been generated. This is the only\n\t\t\t\ttime we can show it to you, so copy it somewhere safe!"), __h(CopyBox, {
    value: props.freshKey.secret
  }));
}